import { useState } from "react";
import "./FileCard.css";

// item: { name, size, type, preview, status: 'uploading' | 'uploaded' | 'error', downloadUrl }
const FileCard = ({ item, onRemove, canRemove = true }) => {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const isImageFile = () =>
        (item.type || "").startsWith("image/") || (item.name || "").match(/\.(jpg|jpeg|png|gif)$/i);

    const isPptFile = () =>
        (item.type || "").includes("presentation") || (item.name || "").match(/\.(ppt|pptx)$/i);

    const isPdfFile = () => (item.name || "").match(/\.pdf$/i);

    const openFile = () => {
        if (item.status !== "uploaded") return;
        if (isImageFile()) {
            setIsPreviewOpen(true);
        } else if (item.downloadUrl) {
            window.open(item.downloadUrl, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <div className={"file-card " + (isImageFile() ? "file-card-img" : "") + (item.status === "error" ? " file-card-error" : "")}>
                {canRemove && (
                    <div className="file-remove" onClick={() => onRemove(item)} title="Remove">
                        ✕
                    </div>
                )}

                {isImageFile() && item.preview ? (
                    <img src={item.preview} alt={item.name} className="file-thumbnail" onClick={openFile} />
                ) : (
                    <div className="file-icon" onClick={openFile} style={{ cursor: item.status === "uploaded" ? "pointer" : "default" }}>
                        {isPptFile() ? (
                            <i className="fas fa-file-powerpoint file-icon-ppt"></i>
                        ) : isPdfFile() ? (
                            "📕"
                        ) : (
                            "📄"
                        )}
                    </div>
                )}

                <div className="file-info">
                    <span className="file-name">{item.name}</span>
                    <span className="file-size">
                        {item.status === "uploading" && <span className="file-status file-status-uploading"><i className="fas fa-spinner fa-spin"></i> Uploading...</span>}
                        {item.status === "error" && <span className="file-status file-status-error"><i className="fas fa-triangle-exclamation"></i> Upload failed</span>}
                        {item.status === "uploaded" && (item.size != null ? `${(item.size / 1024).toFixed(1)} KB` : "")}
                    </span>
                </div>
            </div>

            {isPreviewOpen && (
                <div className="image-overlay" onClick={() => setIsPreviewOpen(false)}>
                    <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
                        <div className="overlay-close" onClick={() => setIsPreviewOpen(false)}>
                            ✕
                        </div>
                        <img src={item.preview || item.downloadUrl} alt={item.name} className="overlay-image" />
                    </div>
                </div>
            )}
        </>
    );
};

export default FileCard;
